module.exports = __webpack_public_path__ + "16bb82bf29f63bc865a413bd97e48689.png";